"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getScrollableParent = void 0;
const overflowRegex = /(auto|scroll)/;
function getScrollableParent(element) {
    const topMostScrollableElement = (document.scrollingElement ||
        document.documentElement);
    let style;
    let excludeStaticParent = null;
    let current = element;
    while (current) {
        style = getComputedStyle(current);
        if (excludeStaticParent === null) {
            excludeStaticParent = style.position === 'absolute';
        }
        if (style.position === 'fixed' || current === topMostScrollableElement)
            return topMostScrollableElement;
        if (excludeStaticParent && style.position === 'static') {
            current = current.parentElement;
            continue;
        }
        if (overflowRegex.test(style.overflow + style.overflowY + style.overflowX))
            return current;
        current = current.parentElement;
    }
    return topMostScrollableElement;
}
exports.getScrollableParent = getScrollableParent;
//# sourceMappingURL=scroll.js.map